import { SiteLayout } from '../../components/SiteLayout';
import { Icon } from '../../components/Icon';
import { ReleaseButton, ReleaseMeta } from '../../components/ReleaseButton';
import { usePageMeta } from '../../lib/meta';
import { useRelease } from '../../lib/releases';

const MAC = ['Native SwiftUI app', 'Inspects real source formats — never upscaled', 'Queue with pause & resume where the source supports it', 'Discover, Library and AI Studio'];
const WIN = ['Native Windows app', 'Discover with filters and similar videos', 'Resumable downloads from authorized sources', 'Local library with search and playback'];

export function Apps() {
  usePageMeta('Desktop apps', 'Ayonix Studio for macOS and Windows: native apps for discovery, downloads from authorized sources and your library. Unsigned previews when published.');
  const release = useRelease();
  return (
    <SiteLayout>
      <div class="container apps-page">
        <header class="center page-hero">
          <h1>Download <span class="grad">Ayonix Studio</span> <br />for Desktop</h1>
          <p class="muted">Native apps for macOS and Windows, sharing your Ayonix account.</p>
        </header>
        <div class="desktop-grid">
          <section class="platform-col" aria-labelledby="mac-h" data-testid="platform-mac">
            <Icon name="apple" size={34} />
            <h2 id="mac-h">macOS App</h2>
            <p class="muted small">macOS 14 or later · built for Apple Silicon (Intel untested)</p>
            <ul class="checks">{MAC.map((f) => <li key={f}><Icon name="check" size={16} />{f}</li>)}</ul>
            <ReleaseButton state={release} platform="mac" size="md" />
            <ReleaseMeta state={release} platform="mac" />
          </section>
          <div class="device-stage" aria-hidden="true">
            <div class="laptop small-laptop"><div class="laptop-screen"><img src="/img/macos-inspect-caminandes.webp" width="1024" height="768" alt="" loading="lazy" /></div><div class="laptop-base" /></div>
            <div class="monitor"><div class="monitor-screen"><img src="/img/windows-launch.webp" width="1024" height="768" alt="" loading="lazy" /></div><div class="monitor-stand" /></div>
          </div>
          <section class="platform-col right" aria-labelledby="win-h" data-testid="platform-windows">
            <Icon name="windows" size={34} />
            <h2 id="win-h">Windows App</h2>
            <p class="muted small">Windows 10 or 11 · 64-bit</p>
            <ul class="checks">{WIN.map((f) => <li key={f}><Icon name="check" size={16} />{f}</li>)}</ul>
            <ReleaseButton state={release} platform="windows" size="md" />
            <ReleaseMeta state={release} platform="windows" />
          </section>
        </div>
        <p class="caption muted center" style="margin-top:24px">Screens: macOS and Windows builds captured in CI. Prefer the browser? <a href="/">Use the web app</a>.</p>
      </div>
    </SiteLayout>
  );
}
